import React, { FC } from 'react';
import Logotype from './styles';
import { Props } from './types';

const Logo: FC<Props> = ({ variant, ...props }) => {
  return <Logotype $variant={variant} {...props} />;
};

export default Logo;
